const ENVIRONMENTS = Object.freeze({
  LOCAL: 'local',
  PRODUCTION: 'production',
  STAGING: 'staging',
  UNKNOWN: 'unknown',
})

export { ENVIRONMENTS }
